import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

interface CreateAccountResult {
  success: boolean;
  uid: string;
  email: string;
  tempPassword: string;
}

interface AccountStatusResult {
  success: boolean;
  uid: string;
  disabled: boolean;
}

interface ResetPasswordResult {
  success: boolean;
  uid: string;
  newPassword: string;
}

// Create a new retailer account (Firebase Auth user)
export const createRetailerAccount = async (
  email: string,
  displayName: string,
  requestId?: string
): Promise<CreateAccountResult> => {
  const createAccount = httpsCallable<
    { email: string; displayName: string; requestId?: string },
    CreateAccountResult
  >(functions, 'createRetailerAccount');

  const result = await createAccount({ email, displayName, requestId });
  return result.data;
};

// Enable or disable a retailer account
export const setRetailerAccountStatus = async (
  uid: string,
  disabled: boolean
): Promise<AccountStatusResult> => {
  const setStatus = httpsCallable<
    { uid: string; disabled: boolean },
    AccountStatusResult
  >(functions, 'setRetailerAccountStatus');

  const result = await setStatus({ uid, disabled });
  return result.data;
};

// Reset a retailer's password and get the new one
export const resetRetailerPassword = async (
  uid: string
): Promise<ResetPasswordResult> => {
  const resetPassword = httpsCallable<
    { uid: string },
    ResetPasswordResult
  >(functions, 'resetRetailerPassword');

  const result = await resetPassword({ uid });
  return result.data;
};
